<script>
import Base from '@backend/Base.vue';
import BoConfig from '@config/BoConfig.js';
import BOGen from '@helper/BOGen.js';

export default {
  extends: Base,
  data(){
    return {
      Name:"Offboarding",
      PageName: "Offboarding",
      ObjectName: "Offboarding",
      input: { type: 'add', approval: 'Y' },      
      filter: {
        status: ''
      },      
      AddItem: true,
      WithLimit: true,
      statusFilter: {
        MNG: "Manager Approval",
        APA: "Approval Admin",
        SPV: "Requester Confirmation",
        DONE: "Done",
        REJECTED: "Rejected"
      }
    }
  },
  mounted(){
    this.$set(this.$root, 'page', this)    
    this.refreshData()        
  },
  methods:{
    resetSearch(){
      this.filter = {
        status: "",
        limit: 50
      }


      this.$router.push({name:this.Name, query: this.filter})
    },
  },
  watch:{
    '$route.query'(){ this.refreshData() },
  }
}
</script>

<template>
  <div class="container-fluid">
    <div class="row page-titles align-items-center">
      <div class="col-md-5">
        <h4 class="text-themecolor">{{PageName}}</h4>
      </div>
      <div class="col-md-7 tr">
        <div class="btn-group">
          <router-link :to="{name:'Offboarding'}" class="btn btn-outline-info" v-tooltip="'List '+ObjectName">
            <i class="fa fa-list"></i><span> List</span>
          </router-link>
          <router-link :to="{name:'OffboardingInit'}" class="btn btn-outline-success" v-tooltip="'Add '+ObjectName">
            <i class="fa fa-plus"></i><span> Add</span>
          </router-link>
        </div>
      </div>
    </div>
    
    <div class="card" v-if="!$route.params.id">
      <div class="card-body card-filter">
        <VForm @resp="search">
          <div class="row">
            <div class="col-sm-3">
              <h4 class="card-title">{{ObjectName}} List <span v-if="data.total">({{(data.total||0).format()}})</span></h4>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-2">
              <Select2 :options="BoConfig.mrPageLimit" v-model="filter.limit"></Select2>
            </div>
            <div class="col-sm-2">
              <Select2 :options="statusFilter" v-model="filter.status" @input="filterStatus">
                <option value="">-- All Status --</option>
              </Select2>
            </div>
            <div class="col-sm-3">
              <div class="has-feedback has-feedback-left">
                <input type="search" v-model="filter.search" @keyup.enter="search" class="form-control" placeholder="Type and hit Enter">
                <div class="form-control-feedback">
                  <i class="icon-search4 text-size-base text-muted"></i>
                </div>
              </div>
            </div>
            <div class="col-sm-1">
              <button type="button" @click="resetSearch()" class="btn btn-warning btn-sm">Reset</button>
            </div>
          </div>
        </VForm>
      </div>            
      <div class="table-responsive ajax-table">
        <table class="table table-striped table-hover table-bordered mb-0">
          <thead>
            <tr>
              <th>#</th>
              <th>Req. Date</th>
              <th>Req. Number</th>
              <th>Req. For</th>
              <th>Req. By</th>
              <th>Employee Name</th>
              <th>CWID</th>
              <th>Department</th>
              <th>Last Date of Work</th>
              <th>Status</th>
              <!-- <th>Action</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, k) in data.data" :key="k">
              <td class="number">{{(data.per_page*(data.current_page-1))+k+1}}</td>
              <td>{{ v.ai_created_at.dates('format2') }}</td>
              <td>{{ v.ai_request_number }}</td>
              <td>{{ v.request_for }}</td>
              <td>{{ v.request_by }}</td>
              <td>
                <div>{{ v.employeename || '-' }}</div>
                <small>{{ v.posTitle }}</small>
              </td>
              <td>{{ v.ai_cwid || '-' }}</td>
              <td>{{ v.ai_department || '-' }}</td>
              <td>{{ moment(v.ai_end_date).format('DD MMM YYYY') }}</td>
              <td>
                <StatusLabel :obj="v"></StatusLabel>
              </td>
            </tr>
            <tr v-if="NotFound">
              <td colspan="99">
                <h3 class="tc">{{NotFound}}</h3>
              </td>
            </tr>
            <tr v-if="data.data===false">
              <td colspan="99">
                <LoadingSpinner light></LoadingSpinner>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-body">
        <div class="pull-right">
          <Pagination :data="data" :limit="3" @pagination-change-page="onPaging"></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
